"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExampleClearAll = void 0;
const react_1 = __importDefault(require("react"));
const ExampleClearAll = (props) => {
    return react_1.default.createElement("a", { onClick: props.clearAll }, "Clear All");
};
exports.ExampleClearAll = ExampleClearAll;
//# sourceMappingURL=ExampleClearAll.js.map